import React from 'react';

export default function CellPhone() {
  return (
    <div className="cellContainer">
      <div className="phoneSvgBox">
        <div className="phoneSvg"></div>
      </div>
      <div className="rightBox">
        <div className="cellTitle">
          <h1>How's It Work?</h1>
        </div>
        <div className="cellSteps">
          <p>1. Download</p>
          <p>2. Install</p>
          <p>3. Run</p>
        </div>
        <div className="cellInfo">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </div>
      </div>
    </div>
  );
}
